<template>
  <AuthLayout
    pitch-title="Quase lá."
    pitch-sub="Escolha uma nova senha para voltar a acessar sua conta na Indicoo."
  >
    <NewPasswordForm />
  </AuthLayout>
</template>

<script>
import AuthLayout from '../components/ui/AuthLayout.vue';
import NewPasswordForm from '../modules/person/components/Forms/NewPasswordForm.vue';

export default {
  name: 'NewPassword',
  components: {
    AuthLayout,
    NewPasswordForm,
  },
};
</script>
